import React, { createContext, useContext, useState, useCallback } from "react";
import { translations, Lang, Translations } from "./translations";

function getInitialLang(): Lang {
  const params = new URLSearchParams(window.location.search);
  const q = params.get("lang");
  if (q === "en" || q === "fi") return q;
  return "fi";
}

interface LangContextValue {
  lang: Lang;
  t: Translations;
  setLang: (lang: Lang) => void;
}

const LangContext = createContext<LangContextValue>({
  lang: "fi",
  t: translations.fi,
  setLang: () => {},
});

export const LangProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [lang, setLangState] = useState<Lang>(getInitialLang);

  const setLang = useCallback((l: Lang) => {
    setLangState(l);
  }, []);

  const value: LangContextValue = {
    lang,
    t: translations[lang],
    setLang,
  };

  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);
